<div class="c-welcome-card" (click)="selectLanguage()">
  <h1 class="c-welcome-card-title">{{locale}}</h1>
  <div class="c-welcome-card-content">
    <h1 class="c-welcome-card-subtitle">{{subtitle}}</h1>
    <p class="c-welcome-card-content">{{content}}</p>
  </div>
</div>
